module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editHeader()
      }
    }
  }, [_vm._v("Edit header menu")]), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editFooter()
      }
    }
  }, [_vm._v("Edit footer")]), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHero'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-content background-1-20-before"
  }, [_c('div', {
    staticClass: "hero-title background-1-50-before background-1-100-after"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "content color-1-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "content color-1-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-subtitle"
  }, [(!_vm.pageEditMode) ? _c('span', {
    staticClass: "content color-2-77",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.subtitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.subtitle),
      expression: "content.heroSection.subtitle"
    }],
    staticClass: "content color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section subtitle",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.subtitle)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "subtitle", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.subtitle))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-description background-1-10-before"
  }, [(!_vm.pageEditMode) ? _c('span', {
    staticClass: "content color-2-77",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-points"
  }, [_vm._l((_vm.content.heroSection.points), function(item, index) {
    return _c('div', {
      staticClass: "hero-points_item background-1-20-before background-1-40-after"
    }, [(!_vm.pageEditMode) ? _c('span', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Text",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.heroSection.points, index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('points')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "hero-image background-1-10-after background-2-4-before"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.featuresSection.hideSection || _vm.content.featuresSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.featuresSection.hideSection || content.featuresSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper features-section landing-page-wrapper__gray"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.featuresSection.hideSection),
      expression: "content.featuresSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showFeatures"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.featuresSection.hideSection) ? _vm._i(_vm.content.featuresSection.hideSection, null) > -1 : (_vm.content.featuresSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.featuresSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.featuresSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showFeatures'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('h2', {
    staticClass: "section-title center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.featuresSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.featuresSection.title),
      expression: "content.featuresSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.featuresSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.featuresSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.featuresSection.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "feature-list"
  }, [_vm._l((_vm.content.featuresSection.items), function(item, index) {
    return _c('div', {
      staticClass: "feature-item"
    }, [(!_vm.pageEditMode && _vm.getDeviceType('mobile')) ? _c('div', {
      staticClass: "feature-title color-1-100",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('mobile')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "feature-title color-1-100",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "feature-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      }),
      attrs: {
        "title": item.altImage
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      staticClass: "landing-page-image-alt",
      attrs: {
        "type": "text",
        "placeholder": "Alt image"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
      staticClass: "landing-page-image-upload",
      attrs: {
        "for": 'feature-image-upload-' + index
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      attrs: {
        "type": "file",
        "id": 'feature-image-upload-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "feature-content"
    }, [(!_vm.pageEditMode && !_vm.getDeviceType('mobile')) ? _c('div', {
      staticClass: "feature-title color-1-100",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('mobile')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "feature-title color-1-100",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
      staticClass: "feature-description color-2-77",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.button.text !== '') ? _c('a', {
      staticClass: "feature-link",
      attrs: {
        "href": item.button.url,
        "title": item.button.text
      }
    }, [_vm._v(_vm._s(item.button.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: "feature-description color-2-77",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.button.text),
        expression: "item.button.text"
      }],
      staticClass: "landing-page-button-edit",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Button text",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.button.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item.button, "text", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.button.url),
        expression: "item.button.url"
      }],
      staticClass: "landing-page-button-edit",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Button url",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.button.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item.button, "url", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.featuresSection.items, index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('features')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.clientSection.hideSection || _vm.content.clientSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.clientSection.hideSection || content.clientSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper clients-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.hideSection),
      expression: "content.clientSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showClients"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.clientSection.hideSection) ? _vm._i(_vm.content.clientSection.hideSection, null) > -1 : (_vm.content.clientSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.clientSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.clientSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showClients'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section center background-1-100-before"
  }, [(!_vm.pageEditMode) ? _c('h2', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.title),
      expression: "content.clientSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.getDeviceType('desktop')) ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.description),
      expression: "content.clientSection.description"
    }],
    staticClass: "section-description center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.description))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.content.clientSection.button.text !== '' && _vm.getDeviceType('desktop')) ? _c('a', {
    staticClass: "section-action background-1-20 color-2-100",
    attrs: {
      "href": _vm.content.clientSection.button.url
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.button.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.text),
      expression: "content.clientSection.button.text"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.url),
      expression: "content.clientSection.button.url"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "url", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [_c('div', {
    staticClass: "logos flex-section"
  }, [(_vm.slidesReady) ? _c('slick', {
    ref: "slick",
    staticClass: "clients-slider",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.content.clientSection.logos), function(item) {
    return _c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(item.image),
        "alt": item.altImage
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-slider-change",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.switchSliderModal()
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mobile-left-section center background-1-100-before"
  }, [(!_vm.pageEditMode && !_vm.getDeviceType('desktop')) ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.description),
      expression: "content.clientSection.description"
    }],
    staticClass: "section-description center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.description))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.content.clientSection.button.text !== '' && !_vm.getDeviceType('desktop')) ? _c('a', {
    staticClass: "section-action background-1-20 color-2-100",
    attrs: {
      "href": _vm.content.clientSection.button.url
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.button.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.text),
      expression: "content.clientSection.button.text"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.button.url),
      expression: "content.clientSection.button.url"
    }],
    staticClass: "landing-page-button-edit center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection.button, "url", $event.target.value)
      }
    }
  }) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.footerCTASection.hideSection || _vm.content.footerCTASection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.footerCTASection.hideSection || content.footerCTASection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper footer-cta-section landing-page-wrapper__blue background-1-20"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerCTASection.hideSection),
      expression: "content.footerCTASection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showfooterCTASection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.footerCTASection.hideSection) ? _vm._i(_vm.content.footerCTASection.hideSection, null) > -1 : (_vm.content.footerCTASection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.footerCTASection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.footerCTASection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.footerCTASection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.footerCTASection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showfooterCTASection'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section flex-column"
  }, [(!_vm.pageEditMode) ? _c('h2', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.footerCTASection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerCTASection.title),
      expression: "content.footerCTASection.title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.footerCTASection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.footerCTASection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.footerCTASection.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cta-content"
  }, [(!_vm.pageEditMode) ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._s(_vm.content.footerCTASection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerCTASection.description),
      expression: "content.footerCTASection.description"
    }],
    staticClass: "section-description",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.footerCTASection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.footerCTASection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.footerCTASection.description))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-actions"
  }, [_vm._l((_vm.content.footerCTASection.buttons), function(item) {
    return (!_vm.pageEditMode) ? _c('a', {
      staticClass: "section-action color-2-100",
      attrs: {
        "href": item.url,
        "title": item.text
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.content.footerCTASection.buttons), function(item) {
    return _c('div', {
      staticClass: "section-buttons-edit"
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "landing-page-button-edit",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Button text",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      staticClass: "landing-page-button-edit",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Button url",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    }) : _vm._e()])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.chapterSection.hideSection || _vm.content.chapterSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.chapterSection.hideSection || content.chapterSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper chapters-section landing-page-wrapper__gray"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.chapterSection.hideSection),
      expression: "content.chapterSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showchapterSection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.chapterSection.hideSection) ? _vm._i(_vm.content.chapterSection.hideSection, null) > -1 : (_vm.content.chapterSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.chapterSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.chapterSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.chapterSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.chapterSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showchapterSection'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('h2', {
    staticClass: "section-title center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.chapterSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.chapterSection.title),
      expression: "content.chapterSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.chapterSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.chapterSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.chapterSection.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "chapters flex-section"
  }, _vm._l((_vm.content.chapterSection.chapters), function(item) {
    return _c('div', {
      staticClass: "chapter-item"
    }, [_c('div', {
      staticClass: "chapter-image",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "title": _vm.getHighImageAlt(item)
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "landing-page-image-upload",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(item)
        }
      }
    }) : _vm._e()]), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
      staticClass: "chapter-title center",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "chapter-title center",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Section title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
      staticClass: "chapter-description",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: "chapter-description",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Section description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.description))]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.howItWorksSection.hideSection || _vm.content.howItWorksSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.howItWorksSection.hideSection || content.howItWorksSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper how-it-works-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.hideSection),
      expression: "content.howItWorksSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showhowItWorksSection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.howItWorksSection.hideSection) ? _vm._i(_vm.content.howItWorksSection.hideSection, null) > -1 : (_vm.content.howItWorksSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.howItWorksSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.howItWorksSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.howItWorksSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.howItWorksSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showhowItWorksSection'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('h2', {
    staticClass: "section-title center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.howItWorksSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.title),
      expression: "content.howItWorksSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.howItWorksSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.howItWorksSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.howItWorksSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "list flex-section"
  }, _vm._l((_vm.content.howItWorksSection.sections), function(item) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-icon"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "title": _vm.getHighImageAlt(item)
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "landing-page-image-upload",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(item)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-title"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-description"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "content-slider"
  }, [_c('slick', {
    ref: "contentSlick",
    staticClass: "slider",
    attrs: {
      "options": _vm.slickOptionsContent
    }
  }, _vm._l((_vm.content.howItWorksSection.sections), function(item) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-icon"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "title": _vm.getHighImageAlt(item)
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "landing-page-image-upload",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(item)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-title"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-description"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()])])
  }), 0)], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.topCTASection.hideSection || _vm.content.topCTASection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.topCTASection.hideSection || content.topCTASection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper cta-section landing-page-wrapper__blue"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.topCTASection.hideSection),
      expression: "content.topCTASection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showtopCTASection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.topCTASection.hideSection) ? _vm._i(_vm.content.topCTASection.hideSection, null) > -1 : (_vm.content.topCTASection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.topCTASection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.topCTASection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.topCTASection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.topCTASection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showtopCTASection'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section"
  }, [_c('div', {
    staticClass: "flex-section flex-column"
  }, [(!_vm.pageEditMode) ? _c('h2', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.topCTASection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.topCTASection.title),
      expression: "content.topCTASection.title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.topCTASection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.topCTASection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.topCTASection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._s(_vm.content.topCTASection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.topCTASection.description),
      expression: "content.topCTASection.description"
    }],
    staticClass: "section-description",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.topCTASection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.topCTASection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.topCTASection.description))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.content.topCTASection.button.text !== '') ? _c('a', {
    staticClass: "section-action background-1-20 color-2-100",
    attrs: {
      "href": _vm.content.topCTASection.button.url
    }
  }, [_vm._v(_vm._s(_vm.content.topCTASection.button.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.topCTASection.button.text),
      expression: "content.topCTASection.button.text"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.topCTASection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.topCTASection.button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.topCTASection.button.url),
      expression: "content.topCTASection.button.url"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.topCTASection.button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.topCTASection.button, "url", $event.target.value)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [_c('div', {
    staticClass: "mockup-shadows"
  }), _vm._v(" "), _c('div', {
    staticClass: "mockup-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.topCTASection.image)
    }),
    attrs: {
      "title": _vm.content.topCTASection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.topCTASection.altImage),
      expression: "content.topCTASection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.topCTASection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.topCTASection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "cta-upload",
    attrs: {
      "for": 'cta-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'cta-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.topCTASection, 'image')
      }
    }
  }) : _vm._e()])])])])]), _vm._v(" "), (_vm.activePopup && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "iconPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Upload icons for: " + _vm._s(_vm.activePopup.title))]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.image)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'image')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImage),
      expression: "activePopup.altImage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.imageHigh)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-high-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-high-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'imageHigh')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImageHigh),
      expression: "activePopup.altImageHigh"
    }],
    attrs: {
      "type": "text",
      "placeholder": "High contrast image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImageHigh)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImageHigh", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.sliderModalShown && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "sliderPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change slider items")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [_vm._l((_vm.content.clientSection.logos), function(item, index) {
    return _c('div', {
      staticClass: "logo-item"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImageHigh),
        expression: "item.altImageHigh"
      }],
      attrs: {
        "type": "text",
        "placeholder": "High contrast image alt"
      },
      domProps: {
        "value": (item.altImageHigh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImageHigh", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "logo-url"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "placeholder": "url"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.clientSection.logos, index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('logos')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.headerEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "headerEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change header menu items")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-header-edit"
  }, [_vm._l((_vm.headerData), function(item, index) {
    return _c('div', {
      staticClass: "repeater-item"
    }, [_c('div', {
      staticClass: "flex-section"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Menu title"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Menu link"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.alt),
        expression: "item.alt"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Menu alt"
      },
      domProps: {
        "value": (item.alt)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "alt", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.headerData, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('header-menu')
      }
    }
  }, [_vm._v("+ Add menu item")])], 2), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardHeaderEdit()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateHeader()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e(), _vm._v(" "), (_vm.footerEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "footerEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change footer data")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', {
    staticClass: "footerLogos"
  }, [_c('div', {
    staticClass: "popup-title"
  }, [_vm._v("Footer logos")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "logosLabel"
    }
  }, [_vm._v("Footer logos label")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.footerData.logosLabel),
      expression: "footerData.logosLabel"
    }],
    attrs: {
      "id": "logosLabel"
    },
    domProps: {
      "value": (_vm.footerData.logosLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.footerData, "logosLabel", $event.target.value)
      }
    }
  })]), _c('br'), _vm._v(" "), _vm._l((_vm.footerData.logos), function(item, index) {
    return _c('div', {
      staticClass: "repeater-item"
    }, [_c('div', {
      staticClass: "flex-section"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Link"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.footerData.logos, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('footer-logos')
      }
    }
  }, [_vm._v("+ Add logos")])], 2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "footer-address"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "addressLabel"
    }
  }, [_vm._v("Address label")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.footerData.addressLabel),
      expression: "footerData.addressLabel"
    }],
    attrs: {
      "id": "addressLabel"
    },
    domProps: {
      "value": (_vm.footerData.addressLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.footerData, "addressLabel", $event.target.value)
      }
    }
  })]), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address data")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.footerData.address),
      expression: "footerData.address"
    }],
    attrs: {
      "id": "address"
    },
    domProps: {
      "value": (_vm.footerData.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.footerData, "address", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.footerData))])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-title"
  }, [_vm._v("Social media")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "socialLabel"
    }
  }, [_vm._v("Social media label")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.footerData.socialLabel),
      expression: "footerData.socialLabel"
    }],
    attrs: {
      "id": "socialLabel"
    },
    domProps: {
      "value": (_vm.footerData.socialLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.footerData, "socialLabel", $event.target.value)
      }
    }
  })]), _c('br'), _vm._v(" "), _vm._l((_vm.footerData.social), function(item2, index) {
    return _c('div', {
      staticClass: "repeater-item"
    }, [_c('div', {
      staticClass: "flex-section"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item2.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal2-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal2-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item2, 'image')
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item2.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high2-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high2-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item2, 'imageHigh')
        }
      }
    })])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item2.url),
        expression: "item2.url"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Social media link"
      },
      domProps: {
        "value": (item2.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item2, "url", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item2.altImage),
        expression: "item2.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Social icon alt"
      },
      domProps: {
        "value": (item2.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item2, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.footerData.social, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('footer-social')
      }
    }
  }, [_vm._v("+ Add social")])], 2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "popup-title"
  }, [_vm._v("Footer menu")]), _vm._v(" "), _vm._l((_vm.footerData.menu), function(item, index) {
    return _c('div', {
      staticClass: "repeater-item"
    }, [_c('div', {
      staticClass: "flex-section"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Menu title"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Menu link"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.alt),
        expression: "item.alt"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Menu alt"
      },
      domProps: {
        "value": (item.alt)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "alt", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.footerData.menu, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('footer-menu')
      }
    }
  }, [_vm._v("+ Add menu item")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardFooterEdit()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateFooter()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e(), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb8ef3be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Index.vue
// module id = 988
// module chunks = 1